<div class="options">
  <div class="markets">
    <app-select-market></app-select-market>
  </div>
  @if (statusTranslations) {
    <div class="status">
      <a>{{ 'STATUS_LABEL' | translate }}</a>
      @for (status of statusList; track status) {
        <div>
          <label [ngClass]="{'disabled': !isStatusSelected(status)}">{{ statusTranslations[status] }}</label>
          <input type="checkbox"
            [ngStyle]="{ 'background-color': getStatusColor(status) }"
            [checked]="isStatusSelected(status)"
            (change)="toggleStatusSelection(status)"/>
        </div>
      }
    </div>
  }
</div>

<div id="map" class="map"></div>

<div id="popup" class="ol-popup">
  <a href="#" id="popup-closer" class="ol-popup-closer"></a>
  <div id="popup-content">
    @for (mission of selectedMissions; track mission) {
      <div class="mission">
        <a [ngStyle]="{'color': getStatusColor(mission.status)}">
          <a style="font-weight: bold;">{{ mission.missionName }}</a><br>
          @for (missionProduct of mission.products; track missionProduct) {
            <a>
              {{ missionProduct.productName }} {{ 'MISSIONS.ORDERED_QUANTITY' | translate }}: {{ missionProduct.productmissionLoadedExpectedMassTotal | number : '1.0-0' }} {{ mission.weightUom }}<br>
            </a>
          }
          <a>{{ 'MISSIONS.FLOWRATE' | translate }}: {{ mission.DMDSExpectedMinFlowrate | number : '1.0-2' }} - {{ mission.DMDSExpectedMaxFlowrate | number : '1.0-2' }} {{ mission.volumeFlowrateUom }}</a>
        </a>
        <img src="assets/images/mission-selection-button.svg" (click)="selectMission(mission)"/>
      </div>
    }
  </div>
</div>